import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "";

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token =
        sessionStorage.getItem("kuddleToken") ||
        localStorage.getItem("kuddleToken");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default api;